import React from 'react';
import SubmitStatus from './Components/Charts/SubmitStatus';
import Special from './Components/Charts/Special';
import Religion from './Components/Charts/Religion';
import RegistrationGraph from './Components/Charts/RegistrationGraph';
import { serverUrl } from '../Constant/Static/config';
import PieChart3D from './Components/Charts/PieChart3D';

function AdminHome() {
    const triggerReload = async () => {
        try {
            await fetch(`${serverUrl}/api/admin/reload`, {
                method: 'POST',
            });
            alert('Reload triggered for all connected clients!');
        } catch (error) {
            console.error('Error triggering reload:', error);
        }
    };
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', paddingTop: '60px' }}>
                <div className='chart-container'>
                    <SubmitStatus />
                </div>
                <div className='chart-container'>
                    <Special />
                </div>
                <div className='chart-container'>
                    <Religion />
                </div>
            </div>
            <div>
                <div className='chart-container'>
                    <RegistrationGraph />
                </div>
            </div>
            <div>
                {/* <div className='chart-container'>
                    <PieChart3D />
                </div> */}
            </div>
        </div>
    )
}

export default AdminHome;